import React from 'react';
import { FeedbackFish } from '@feedback-fish/react';
import { NavItem, NavLink } from 'reactstrap';

// You need to replace this with your actual project ID from feedback.fish dashboard
const FEEDBACK_FISH_PROJECT_ID = "85d229f35df99f"; // Replace with your actual project ID

const FeedbackButton = ({ userEmail }) => {
    return (
        <NavItem>
            <FeedbackFish projectId={FEEDBACK_FISH_PROJECT_ID} userId={userEmail}>
                <NavLink 
                    style={{
                        cursor: 'pointer',
                        color: '#51cbce',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    <i className="nc-icon nc-chat-33" style={{ marginRight: '5px' }} />
                    Send Feedback
                </NavLink>
            </FeedbackFish>
        </NavItem>
    );
};

export default FeedbackButton;